exports.components = {
  "component---src-pages-epk-js": () => import("./../../../src/pages/epk.js" /* webpackChunkName: "component---src-pages-epk-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-merchandise-js": () => import("./../../../src/pages/merchandise.js" /* webpackChunkName: "component---src-pages-merchandise-js" */)
}

